const render = ({siteid, publisherid, securitykey}) => {
  return `
<style>
  .headline{
    width: 90%;
    padding:10px 5%;
    color: black;
    background-color: white;
    text-align: left;
    font: 14px/20px "Trebuchet MS", Arial, Helvetica, sans-serif;
  }

        .btn_continue {
         padding: 15px 60px;
         }




  </style>

    <link href="https://shoppersreact.com/styles/surveyoffers.css" type="text/css" rel="stylesheet" />
    <link href="https://regreact.com/newoffers/blue784.css" type="text/css" rel="stylesheet" />
    <script type="text/javascript" src="https://shoppersreact.com/scripts/modernizer.js"></script>

    <script type="text/javascript" src="https://shoppersreact.com/scripts/modernizer.js"></script>
  <link href="css/fonts.css" rel="stylesheet" type="text/css" media="all" />
  <link href="css/frontpage_styles2.css" rel="stylesheet" type="text/css" media="all" />

  <script type="text/javascript">

        //Config variables (Please do not change)
        var rm_survey_type = "";
        var rm_offer_type = "A";
        var rm_siteID = "${siteid}";
        var rm_pid = "${publisherid}";   //rm_pid is PublisherID e.g rm_pid="104"
        var rm_key = "${securitykey}"; //rm_key is Security Key e.g rm_key="0ed6850b9dfb"
        var rm_country = "1";
        var rm_signupform = "";



        //Required Fields, otherwise user will be redireced to signup form. Please change the test values
        var rm_fname = "{firstName}"; //First Name
        var rm_lname = "{lastName}"; //Last Name
        var rm_email = "{email}"; //Email Address

        /* Optional Fields: Required to Prefill fields, otherwise Prefill will not work - Pass value in double quotes or leave blank */
        var rm_gender = "{gender}"; //Gender e.g gender="Male" or gender="F"
        var rm_add1 = "{address1}"; //Address 1
        var rm_add2 = "{address2}"; //Address 2
        var rm_city = "{city}"; //City
        var rm_state = "{state}";  //2 Letters US States code e.g state="NY"
        var rm_zip = "{zip}"; //Zip Code
        var rm_dobday = "{dob_dd}"; //Date of Birth Day e.g dobday="08" or dobday="28"
        var rm_dobmonth = "{dob_mm}"; //Date of Birth Month e.g dobmonth="08" or dobmonth="12"
        var rm_dobyear = "{dob_yyyy}"; //Date of Birth Year e.g dobday="08" or dobday="12"
        var rm_phone1 = "{phone_areaCode}"; //Phone 1  e.g phone1="111"
        var rm_phone2 = "{phone_prefix}"; //Phone 2  e.g phone2="222"
        var rm_phone3 = "{phone_suffix}"; //Phone 3 e.g phone3="3333"
        var rm_report_id = "{pe_key}";
        var rm_sub_id = "{sid1}";
        var rm_width = "";

        //Set Messages (Optional)
        var rm_exit_url = "{nextURL}";  //should start with http or https
        var rm_thanks = "<div class='join_msg'>Thank you for signing up the offers. Please check your inbox for further information.</div>";  //if the rm_exit_url is not set, then the thanks message will be displayed to user at end of path.

    </script>

    <!-- if jquery is already included, please remove following link -->
    <script type="text/javascript" src="https://shoppersreact.com/reactionads_v17.js"></script>



       <div class="container">
       <div style="margin-top:10px;font-size:20px;">
         <span style="font-size:24px;color:#28537f;">Member Questionnaire</span><br /><br />
  You have joined up with Surveyrewardsonline.com, simply select Yes or No to any of the options below which may be of interest to you. When complete, please click Continue.<br /><br />

         </div>
         <div class="main_content" style="text-align: left; max-width: 850px;">
           <div id="reactionads" class="rm_container"></div>
         </div>
       </div>

      <br />
      </div>
  `.trim()
};

export default render;